var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-9_10_",
    d: "M19 2.82568H0.75V20.1632H19V2.82568Z",
    stroke: "url(#paint0_linear_1_875)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-19_8_",
    d: "M0.75 7.38818H19",
    stroke: "url(#paint1_linear_1_875)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-20_11_",
    d: "M5.3125 1V4.65",
    stroke: "url(#paint2_linear_1_875)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-20-Copy_2_",
    d: "M14.4375 1V4.65",
    stroke: "url(#paint3_linear_1_875)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-21_45_",
    d: "M7.13721 13.0786L9.50295 15.6L12.6122 10.125",
    stroke: "url(#paint4_linear_1_875)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_875",
    x1: 10.7875,
    y1: 0.0966328,
    x2: 11.7168,
    y2: 30.8127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD749B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281AC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_875",
    x1: 10.7875,
    y1: 7.23078,
    x2: 10.7906,
    y2: 9.00405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD749B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281AC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_875",
    x1: 5.8625,
    y1: 0.425463,
    x2: 6.60486,
    y2: 6.81162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD749B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281AC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_875",
    x1: 14.9875,
    y1: 0.425463,
    x2: 15.7299,
    y2: 6.81162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD749B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281AC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_875",
    x1: 10.1485,
    y1: 9.26319,
    x2: 10.4573,
    y2: 18.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD749B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281AC8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.0ad45c44b58d12c7958e404f7a1223fd.svg";
export { ForwardRef as ReactComponent };